import { connect } from 'react-redux';

export interface RDLinkLabelInferface {
  name: string;
  title: string;
  nodeRef: string;
  readOnly: boolean;
  cdValidDoc: any;
  cdWorkingDoc: any;
}

class RDLinkLabel extends window.React.PureComponent<RDLinkLabelInferface> {
    //from response we get title as null, if we get something normal, we can use title from props
    getTitle = () => {
        const{ cdValidDoc } = this.props;
        if(cdValidDoc){
            return window.Alfresco.messages.global['edocat.docDetail.tracker.cdValidDoc.title'];
        }
        return window.Alfresco.messages.global['edocat.docDetail.tracker.cdWorkingDoc.title'];
      }
  render() {
    const {nodeRef, name} = this.props;

    return (
      <div className="fieldset-wrap form-instance-wrapper view-form rddlink">
        <fieldset className={`form-fieldset`}>
            <div className="form-row simple-row">
                <label>{this.getTitle()}</label>
                <div>
				    <a className="rddlValueLink" target="_blank" href={`./document-details?nodeRef=${nodeRef}`}>{name}</a>
                </div>
            </div>
        </fieldset>
      </div>
    );
  }
}

const mapStateToProps = (state:any) => ({
    
    name: state.actions.eNode.cdValidDoc?.name ?? state.actions.eNode.cdWorkingDoc?.name,
    title: state.actions.eNode.cdValidDoc?.title ?? state.actions.eNode.cdWorkingDoc?.title,
    nodeRef: state.actions.eNode.cdValidDoc?.nodeRef ?? state.actions.eNode.cdWorkingDoc?.nodeRef,
    cdValidDoc: state.actions.eNode.cdValidDoc,
    cdWorkingDoc: state.actions.eNode.cdWorkingDoc,
});

export default connect(mapStateToProps)(RDLinkLabel);